import {
  Action,
  ActiveFilters,
  Count,
  Filter,
  Label,
} from '@/scenes/Gallery/ActiveFilters/styles';
import { inject, observer } from 'mobx-react';
import { IGalleryStore } from '@/stores/Gallery';
import { FC } from 'react';

interface GalleryActiveFiltersProps {
  galleryStore: IGalleryStore;
}

const GalleryActiveFilters: FC<any> = ({
  galleryStore,
}: GalleryActiveFiltersProps) => {
  const { activeFilters, toggleFilter } = galleryStore;

  const mappedFilters = activeFilters.reduce((result, group) => {
    const array = result;

    const options = group.options.map((o) => ({
      group,
      option: o,
    }));

    array.push(...options);

    return array;
  }, []);

  if (!mappedFilters.length) return;

  return (
    <ActiveFilters>
      {mappedFilters.map(({ group, option }) => (
        <Filter key={group.type + option.value}>
          <Label>{option.value}</Label>
          <Count>{option.total}</Count>
          <Action onClick={() => toggleFilter(group, option, false)} />
        </Filter>
      ))}
    </ActiveFilters>
  );
};

export default inject('galleryStore')(observer(GalleryActiveFilters));
